module.exports = __webpack_public_path__ + "static/media/pcb_toggle.e0c09cc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcb_toggle.jpg
// module id = 1111
// module chunks = 0